import { React, useState, useEffect } from "react";
import images from "../ComponentsHelpers/Images.js";
import hexc4infologo from "../Resources/favicons/hexc4-info-50.png";
import hex33infologo from "../Resources/favicons/hex33-info-50.png";
import Header from "../ComponentsHelpers/Header.js";
import Loop from "../ComponentsHelpers/Loop.js";
import Footer from "../ComponentsHelpers/Footer.js";
import "../Global.css";
import InfoBubble from "../ComponentsHelpers/InfoBubble.js";

function Home() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showPopup, setShowPopup] = useState(false);

  const imagesList = [
    { id: 0, src: images.dog, alt: "Me and my dog FINN" },
    { id: 1, src: images.cat, alt: "Me with cat" },
    //{ id: 2, src: images.concert, alt: "Me at concert" },
    { id: 3, src: images.food, alt: "nyc ice cream"},
    { id: 4, src: images.england, alt: "england study abroad" },
    { id: 7, src: images.fam, alt: "Me and the fam" },
    { id: 8, src: images.cafe, alt: "Me at Spain cafe" },
    { id: 11, src: images.news, alt: "me in dc" },
    { id: 12, src: images.transit, alt: "me on tube" },
    { id: 13, src: images.city, alt: "yung me city view" },
    { id: 14, src: images.war, alt: "family fleeing war" },
    { id: 15, src: images.boston, alt: "boston common image" },
    
  ];

  const captionsList = [
    "I am proudly related to my kid brother Finn (BEST DOG EVER).",
    "I am a current cat godfather.",
    //"I am a frequenter of concerts and music festivals.",
    "I am a food enthusiast, especially NYC street meat and ice cream trucks.",
    "I am a former London, Sydney, and Dublin study abroad student.",
    "I am a brother, son, grandson, nephew, and cousin to a BIG fam including 12 aunts & uncs, 28 first cousins, etc. My family is everything to me.",
    "I am big on café culture as an Albanian—a country with some of the most cafés per capita.",
    "I am an avid news reader, always keeping an eye on D.C. and international affairs.",
    "I am a public transit fan as a son of a bus driver and rider of NYC’s MTA, Boston’s MBTA, London’s Tube, & more.",
    "I am Bronx born and Westchester raised, growing up between suburban life and most family in NYC.",
    "I am a first-generation American and college student. Both sides of my family fled Kosova during the Yugoslav Wars in the 90s; pictured above are my Grandpa, Grandma, and Uncle.",
    "I am slowly falling in love with Boston."
  ];

  const showInfo = () => {
    setShowPopup(true);
  };

  const hideInfo = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); 
  let content;
  if (windowWidth >= 768) {
    
    content = (
      <div className="Home">
        <button onClick={showInfo}>
          <img className="ilogo" src={hexc4infologo} alt="More info" />
        </button>
        {showPopup && <InfoBubble hideInfo={hideInfo} />}
        <div className="left-col">
          <Header bigWindow={true} />
          <Footer />
        </div>
        <div className="right-col">
          <Loop imagesList={imagesList} captionsList={captionsList} />{" "}
          {}
        </div>
      </div>
    );
  } else {
    content = (
      <div className="Home">
        <button onClick={showInfo}>
          <img className="ilogo" src={hex33infologo} alt="More info" />
        </button>
        {showPopup && <InfoBubble hideInfo={hideInfo} />}
        <div className="left-col">
          <Header bigWindow={false} />
        </div>
        <div className="right-col">
          <Loop imagesList={imagesList} captionsList={captionsList} />{" "}
          {/* perhaps change data structure so that the images line up with the captions better */}
        </div>
        <div className="left-col">
          <Footer />
        </div>
      </div>
    );
  }

  return <div>{content}</div>;
}

export default Home;
